<!--
  Fix round 1 (DEV-872): a raiz NÃO é mais <button> — <button> dentro de <button>
  é HTML inválido (conteúdo interativo aninhado), com árvore de acessibilidade
  indefinida e nome acessível da linha absorvendo o texto do CTA.

  Padrão adotado: "stretched link". O título vira o botão real
  (`.nt-item__main`), e o SCSS estica um `::after` dele até cobrir a linha
  inteira via `position: absolute; inset: 0` ancorado no `.nt-item` (raiz com
  `position: relative`). O CTA continua um <button> IRMÃO, elevado por
  `z-index` para ficar clicável acima do overlay. Os dois botões nunca se
  aninham: teclado, foco e nome acessível de cada um chegam "de graça" do
  próprio elemento nativo, sem reimplementar semântica de botão com
  role/tabindex/keydown (que o commit ddbd09bc já rejeitou para este repo).
-->
<div class="nt-item" [class.is-read]="item().read">
  <span [class]="dotClass()">
    <lkt-icon [name]="item().icon" [size]="17" />
  </span>

  <span class="nt-item__txt">
    <button type="button" class="nt-item__main" [attr.data-cy]="dataCy()" (click)="onSelect()">
      <span class="nt-item__title"
        ><strong>{{ item().subject }}</strong> {{ item().message }}</span
      >

      @if (item().body) {
        <span class="nt-item__body">{{ item().body }}</span>
      }

      <span class="nt-item__meta">{{ item().timeLabel }}</span>
    </button>

    @if (item().ctaLabel) {
      <span class="nt-item__actions">
        <button
          type="button"
          class="nt-item__cta"
          [attr.data-cy]="ctaDataCy()"
          (click)="onCtaSelect()">
          {{ item().ctaLabel }}
        </button>
      </span>
    }
  </span>

  <!--
    O marcador permanece no DOM quando lido (visibility: hidden) para não
    colapsar a terceira coluna do grid e provocar reflow da lista inteira.
  -->
  <span class="nt-item__unread" aria-hidden="true"></span>
</div>
